import { AbstractControl, FormGroup } from "@angular/forms";

export const capitalizeWords = (str: string) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getControlErrors = (
  formGroup: FormGroup,
  key: string,
  fieldName?: string
): Array<{ state: boolean; message: string }> => {
  const control: AbstractControl | null = formGroup.controls[key];
  const fieldErrors: Array<{ state: boolean; message: string }> = [];

  if (control && control.touched && control.errors) {
    Object.entries(control.errors).forEach(([errorKey, errorValue]) => {
      let errorMessage = "";

      switch (errorKey) {
        case "required":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } is mandatory`;
          break;
        case "email":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } must be a valid email address`;
          break;
        case "minlength":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } must be at least ${errorValue["requiredLength"]} characters long`;
          break;
        case "maxlength":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } cannot exceed ${errorValue["requiredLength"]} characters`;
          break;
        case "pattern":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } has an invalid format`;
          break;
        case "blank":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } cannot be empty`;
          break;
        case "invalidUrl":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } is not a valid URL`;
          break;
        case "invalidLongitude":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } should be between -180 and 180`;
          break;
        case "invalidLatitude":
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } should be between -90 and 90`;
          break;
        default:
          errorMessage = `${
            fieldName ? fieldName : capitalizeWords(key)
          } has an error (${errorKey})`;
      }

      fieldErrors.push({ state: true, message: errorMessage });
    });
  }

  return fieldErrors;
};
